import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {Router} from '@angular/router';
import {User} from '../api/interfaces/user.interface';
import {ServicePackage} from '../api/interfaces/packages.interface';
import {UserService} from '../api/services/user.service';
import {PackageService} from '../api/services/package.service';
import {PaymentService} from '../api/services/payment.service';
import {ConfirmationDialogComponent} from './confirmation-dialog.component';
import {
  MaporiumAccordionItemComponent
} from '../shared/components/maporium-accordion/maporium-accordion-item.component';
import {CdkAccordion} from '@angular/cdk/accordion';
import {environment} from '../../environments/environment';
import {loadStripe} from '../shared/helpers/stripe-loader';
import {isEduEmail} from '../shared/helpers/edu.util';
import {UserProfileDialogComponent} from './user-profile-dialog.component';
import {EndTrialFrameComponent} from './end-trial-frame.component';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'maporium-account-dialog',
  styles: [`
    ::ng-deep .account-section-danger .accordion-item-header {
      background-color: #fae6e6 !important;
      color: #cc0000 !important;
    }

    ::ng-deep .plan-menu.mat-mdc-menu-panel {
      min-width: 160px;
    }

    ::ng-deep .plan-menu .mat-mdc-menu-item {
      min-height: 16px !important;
    }

    ::ng-deep .plan-menu .mat-mdc-menu-item .mdc-list-item__primary-text {
      font-size: 14px !important;
    }

    ::ng-deep .plan-menu .mat-mdc-menu-item .mat-mdc-menu-item-text {
      display: flex;
      align-items: center;
      width: 100%;
    }

    ::ng-deep .plan-menu .mat-mdc-menu-item .plan-item-icon {
      display: inline-block;
      width: 20px;
      text-align: center;
      flex-shrink: 0;
    }

    .account-input {
      border: 1px solid rgb(118, 118, 118);
      border-radius: 4px;
      outline: none;
      background: #FFFFFF;
      padding: 2px 6px;
      font-size: 14px;
      font-family: inherit;
      height: 23px;
      box-sizing: content-box;
    }

    .account-input::placeholder {
      font-family: inherit;
      font-size: 14px;
      opacity: 1;
    }

    .account-input:focus {
      border-color: rgb(118, 118, 118);
    }

    .account-input-compact {
      width: 200px;
    }

    .plan-dropdown {
      display: inline-flex;
      align-items: center;
      border: 1px solid rgb(118, 118, 118);
      border-radius: 4px;
      background: #FFFFFF;
      padding: 2px 6px;
      height: 23px;
      cursor: pointer;
      font-size: 14px;
      font-family: inherit;
      box-sizing: content-box;
      outline: none;
      min-width: 160px;
    }

    .plan-dropdown .plan-name {
      flex: 1;
      white-space: nowrap;
    }

    .plan-dropdown .dropdown-arrow {
      font-size: 10px;
      color: #333;
      margin-left: 8px;
    }

    .account-row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 6px 8px;
      padding: 6px 0;
    }

    .row-icon {
      width: 30px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: #555;
    }

    .row-info {
      flex-shrink: 1;
      font-size: 13px;
      color: #666;
      min-width: 0;
    }

    .row-actions {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      gap: 6px;
      margin-left: auto;
    }

    .cancel-btn {
      width: 29px;
      height: 29px;
      border-radius: 50%;
      background: transparent;
      color: #333;
      border: 1.5px solid #333;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      line-height: 1;
      padding: 0;
      box-sizing: border-box;
    }

    .cancel-btn:hover {
      border-color: #000;
      color: #000;
    }

    .confirm-btn {
      background-color: #3D85C6;
      color: white;
      border: none;
      padding: 0 16px;
      font-family: 'Oswald', sans-serif;
      font-size: 15px;
      text-transform: uppercase;
      border-radius: 6px;
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 29px;
      box-sizing: border-box;
    }

    .confirm-btn:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .confirm-btn:hover:not(:disabled) {
      background-color: #2a6ba6;
    }

    .close-account-btn {
      background-color: #cc0000;
      color: white;
      border: none;
      padding: 0 20px;
      font-family: 'Oswald', sans-serif;
      font-size: 15px;
      text-transform: uppercase;
      border-radius: 6px;
      cursor: pointer;
      height: 29px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
    }

    .close-account-btn:hover {
      background-color: #a30000;
    }

    .stripe-badge {
      text-align: center;
      padding: 4px 0 2px 0;
    }

    .stripe-badge img {
      height: 20px;
    }

    .input-wide {
      flex: 1;
      min-width: 0;
    }

    .card-display {
      font-family: 'Courier New', monospace;
      font-size: 14px;
      color: #333;
      padding: 2px 6px;
      height: 23px;
      display: inline-flex;
      align-items: center;
      border: 1px solid rgb(118, 118, 118);
      border-radius: 4px;
      background: white;
      cursor: pointer;
      box-sizing: content-box;
      flex: 1;
      min-width: 0;
    }

    .card-display span {
      margin-right: 16px;
    }

    #account-card-element {
      padding: 6px 6px 0 6px;
      height: 21px;
      border: 1px solid rgb(118, 118, 118);
      border-radius: 4px;
      background: white;
      box-sizing: content-box;
      flex: 1;
      min-width: 0;
    }

    .custom-toggle {
      display: inline-flex;
      border: 1px solid rgb(118, 118, 118);
      border-radius: 4px;
      overflow: hidden;
      background: white;
      height: 27px;
    }

    .toggle-option {
      display: flex;
      align-items: center;
      padding: 0 12px;
      cursor: pointer;
      font-size: 13px;
      user-select: none;
      border-right: 1px solid rgb(118, 118, 118);
    }

    .toggle-option:last-child {
      border-right: none;
    }

    .toggle-option.selected {
      font-weight: 600;
      background-color: #e7f1fa;
    }

    .danger-message {
      font-size: 13px;
      color: #666;
    }
  `],
  template: `
    <div class="w-100 d-flex justify-content-between align-items-center dialog-header">
      <h2 class="align-items-center d-flex m-0 p-0">
        <span class="material-symbols-rounded me-2">account_circle</span>{{ 'USER_ACCOUNT.HEADER.TITLE' | translate }}
      </h2>
      <span class="icon-smap-action-close close-button" (click)="close()" [matTooltip]="'SHARE_DIALOG.CLOSE_TOOLTIP' | translate"></span>
    </div>
    <div mat-dialog-content>
      <div *ngIf="isDelinquent" [style.background]="payNowSuccess ? '#edf5ea' : '#fae6e6'"
           style="padding: 12px 16px; border-radius: 8px; margin-bottom: 12px; text-align: center;">

        <!-- Success state -->
        <div *ngIf="payNowSuccess">
          <p style="color: #6aa84f; margin: 0; font-size: 14px; font-weight: normal;">
            {{ 'USER_ACCOUNT.DELINQUENT.SUCCESS' | translate:{ amount: '$' + delinquentAmount, plan: (delinquentPackage?.title || '') } }}
          </p>
        </div>

        <!-- Error/payment state -->
        <ng-container *ngIf="!payNowSuccess">
          <p style="color: #cc0000; margin: 0 0 8px 0; font-size: 14px;">
            {{ 'USER_ACCOUNT.DELINQUENT.ERROR' | translate:{ amount: '$' + delinquentAmount, plan: (delinquentPackage?.title || '') } }}
          </p>

          <!-- Default state: PAY NOW button -->
          <div *ngIf="!payNowMode">
            <button class="confirm-btn" style="background-color: #cc0000; margin: 0 auto;" (click)="startPayNow()">{{ 'USER_ACCOUNT.BUTTONS.PAY_NOW' | translate }}</button>
          </div>

          <!-- Card entry state -->
          <div *ngIf="payNowMode">
            <div id="delinquent-card-element" style="padding: 6px; border: 1px solid rgb(118,118,118); border-radius: 4px; background: white; margin-bottom: 8px;"></div>
            <div class="d-flex justify-content-center align-items-center" style="gap: 8px;">
              <button class="cancel-btn" (click)="cancelPayNow()">&times;</button>
              <button class="confirm-btn" style="background-color: #cc0000;"
                      [disabled]="!delinquentCardComplete || delinquentProcessing"
                      (click)="processPayNow()">
                {{ delinquentProcessing ? ('USER_ACCOUNT.BUTTONS.PROCESSING' | translate) : ('USER_ACCOUNT.BUTTONS.PAY' | translate) }}
              </button>
            </div>
          </div>
        </ng-container>
      </div>

      <maporium-end-trial-frame (trialEnded)="refreshUser()"></maporium-end-trial-frame>

      <cdk-accordion [multi]="true">
        <!-- SERVICE SECTION -->
        <div class="account-section-service">
          <maporium-accordion-item [title]="'USER_ACCOUNT.SECTION.SERVICE' | translate">
            <!-- Plan Row -->
            <div class="account-row">
              <div class="row-icon">
                <i [ngClass]="selectedPackage?.icon || 'icon-smap-plan-seeker'"></i>
              </div>
              <div class="plan-dropdown" [matMenuTriggerFor]="planMenu">
                <span class="plan-name">{{ selectedPackage?.title || ('USER_ACCOUNT.SELECT_PLAN' | translate) }}</span>
                <span class="dropdown-arrow">&#9660;</span>
              </div>
              <mat-menu #planMenu="matMenu" class="plan-menu">
                @for (pkg of publicPackages; track pkg.id) {
                  <button mat-menu-item (click)="selectPlan(pkg)">
                    <i class="plan-item-icon me-2" [ngClass]="pkg.icon || ''"></i>
                    <span>{{ pkg.title }}</span>
                  </button>
                }
              </mat-menu>
              <div class="row-info">{{priceInfoText}}</div>
              <div class="row-actions" *ngIf="planDirty">
                <button class="cancel-btn" (click)="cancelPlan()" [matTooltip]="'USER_ACCOUNT.BUTTONS.CANCEL' | translate">&times;</button>
                <button class="confirm-btn" (click)="confirmPlan()">{{ 'USER_ACCOUNT.BUTTONS.CONFIRM' | translate }}</button>
              </div>
            </div>
            <!-- Email Row -->
            <div class="account-row">
              <div class="row-icon">
                <i class="icon-smap-user-email"></i>
              </div>
              <input #emailInput class="account-input account-input-compact"
                     type="email"
                     [placeholder]="'USER_ACCOUNT.PLACEHOLDER.EMAIL' | translate"
                     [(ngModel)]="currentEmail"
                     (ngModelChange)="onEmailChange()">
              <input class="account-input account-input-compact" *ngIf="emailDirty"
                     type="email"
                     [placeholder]="'USER_ACCOUNT.PLACEHOLDER.EMAIL_CONFIRM' | translate"
                     [(ngModel)]="currentEmailConfirm"
                     (ngModelChange)="onEmailConfirmChange()">
              <div class="row-actions" *ngIf="emailDirty">
                <button class="cancel-btn" (click)="cancelEmail()" [matTooltip]="'USER_ACCOUNT.BUTTONS.CANCEL' | translate">&times;</button>
                <button class="confirm-btn" [disabled]="!emailValid" (click)="confirmEmail()">{{ 'USER_ACCOUNT.BUTTONS.CONFIRM' | translate }}</button>
              </div>
            </div>
          </maporium-accordion-item>
        </div>

        <!-- BILLING SECTION -->
        <div class="account-section-billing">
          <maporium-accordion-item [title]="'USER_ACCOUNT.SECTION.BILLING' | translate">
            <!-- Billing Period Row -->
            <div class="account-row">
              <div class="row-icon">
                <i class="icon-smap-billing-cycle"></i>
              </div>
              <div class="custom-toggle">
                <div class="toggle-option" [class.selected]="currentBillingPeriod === 'monthly'" (click)="billingPeriodFocused = true; onBillingPeriodChange('monthly')">
                  {{ 'USER_ACCOUNT.PERIOD.MONTHLY' | translate }}
                </div>
                <div class="toggle-option" [class.selected]="currentBillingPeriod === 'yearly'" (click)="billingPeriodFocused = true; onBillingPeriodChange('yearly')">
                  {{ 'USER_ACCOUNT.PERIOD.YEARLY' | translate }}
                </div>
              </div>
              <div class="row-info">{{chargeInfoText}}</div>
              <div class="row-actions" [style.visibility]="(billingPeriodFocused || billingPeriodDirty) ? 'visible' : 'hidden'" [style.pointer-events]="(billingPeriodFocused || billingPeriodDirty) ? null : 'none'">
                <button class="cancel-btn" (click)="cancelBillingPeriod()" [matTooltip]="'USER_ACCOUNT.BUTTONS.CANCEL' | translate">&times;</button>
                <button class="confirm-btn" [disabled]="currentBillingPeriod === savedBillingPeriod" (click)="confirmBillingPeriod()">{{ 'USER_ACCOUNT.BUTTONS.CONFIRM' | translate }}</button>
              </div>
            </div>
            <!-- Billing Name Row -->
            <div class="account-row">
              <div class="row-icon">
                <i class="icon-smap-account-individual"></i>
              </div>
              <input #billingNameInput class="account-input input-wide"
                     type="text"
                     [placeholder]="'USER_ACCOUNT.PLACEHOLDER.BILLING_NAME' | translate"
                     [(ngModel)]="currentBillingName"
                     (ngModelChange)="onBillingNameChange()">
              <div class="row-actions" *ngIf="billingNameDirty">
                <button class="cancel-btn" (click)="cancelBillingName()" [matTooltip]="'USER_ACCOUNT.BUTTONS.CANCEL' | translate">&times;</button>
                <button class="confirm-btn" [disabled]="!billingNameValid" (click)="confirmBillingName()">{{ 'USER_ACCOUNT.BUTTONS.CONFIRM' | translate }}</button>
              </div>
            </div>
            <!-- Card Number Row -->
            <div class="account-row">
              <div class="row-icon">
                <i class="icon-smap-billing-card"></i>
              </div>
              <div *ngIf="!cardEditing" class="card-display" (click)="startCardEdit()">
                <span>**** **** **** {{paymentMethodInfo?.last4 || '----'}}</span>
                <span>{{paymentMethodInfo ? (padZero(paymentMethodInfo.expMonth) + '/' + paymentMethodInfo.expYear) : '--/----'}}</span>
                <span>***</span>
              </div>
              <div *ngIf="cardEditing" id="account-card-element"></div>
              <div class="row-actions" *ngIf="cardEditing">
                <button class="cancel-btn" (click)="cancelCard()" [matTooltip]="'USER_ACCOUNT.BUTTONS.CANCEL' | translate">&times;</button>
                <button class="confirm-btn" [disabled]="!cardComplete" (click)="confirmCard()">{{ 'USER_ACCOUNT.BUTTONS.CONFIRM' | translate }}</button>
              </div>
            </div>
            <div class="stripe-badge">
              <img src="assets/powered_by_stripe.svg" [alt]="'USER_ACCOUNT.STRIPE_ALT' | translate" />
            </div>
          </maporium-accordion-item>
        </div>

        <!-- DANGER ZONE SECTION -->
        <div class="account-section-danger">
          <maporium-accordion-item [title]="'USER_ACCOUNT.SECTION.DANGER_ZONE' | translate">
            <div class="account-row">
              <div class="row-icon">
                <i class="icon-smap-concept-warning" style="color: #cc0000;"></i>
              </div>
              <div>
                <button class="close-account-btn" (click)="onCloseAccount()">{{ 'USER_ACCOUNT.BUTTONS.CLOSE_ACCOUNT' | translate }}</button>
              </div>
              <div class="danger-message">{{ 'USER_ACCOUNT.DANGER.CONFIRMATION_NOTICE' | translate }}</div>
            </div>
          </maporium-accordion-item>
        </div>
      </cdk-accordion>
    </div>
  `,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    FormsModule,
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MaporiumAccordionItemComponent,
    CdkAccordion,
    EndTrialFrameComponent,
    TranslatePipe,
  ],
  standalone: true
})
export class UserAccountDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('emailInput') emailInputRef: ElementRef<HTMLInputElement> | undefined;
  @ViewChild('billingNameInput') billingNameInputRef: ElementRef<HTMLInputElement> | undefined;

  // Simple string properties — no FormControls
  currentPlanId = '';
  currentEmail = '';
  currentEmailConfirm = '';
  currentBillingName = '';
  currentBillingPeriod: 'monthly' | 'yearly' = 'monthly';

  // Saved state for dirty comparison
  savedPlanId = '';
  savedEmail = '';
  savedBillingName = '';
  savedBillingPeriod: 'monthly' | 'yearly' = 'monthly';

  // Data
  currentUser: User | undefined;
  publicPackages: ServicePackage[] = [];
  paymentMethodInfo: { last4: string; expMonth: number; expYear: number; brand: string } | null = null;

  // Dirty flags
  planDirty = false;
  emailDirty = false;
  billingPeriodDirty = false;
  billingNameDirty = false;

  // Focus flags
  billingPeriodFocused = false;

  // Card
  cardEditing = false;
  cardComplete = false;

  // Delinquent pay-now flow
  payNowMode = false;
  delinquentCardComplete = false;
  delinquentProcessing = false;
  payNowSuccess = false;
  private delinquentCard: any;

  // Loading
  private userLoaded = false;
  private packagesLoaded = false;

  // Stripe
  private stripe: any;
  private card: any;
  private stripeInitialized = false;

  get emailValid(): boolean {
    if (!this.currentEmail) return false;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(this.currentEmail) && this.currentEmail === this.currentEmailConfirm && this.currentEmail !== this.savedEmail;
  }

  get billingNameValid(): boolean {
    return !!this.currentBillingName?.trim() && this.currentBillingName.trim() !== this.savedBillingName;
  }

  get isOnActiveTrial(): boolean {
    const sub = this.currentUser?.subscription;
    return !!(sub?.isTrial && sub?.expirationDate && new Date(sub.expirationDate) > new Date());
  }

  get hasActiveSubscription(): boolean {
    const sub = this.currentUser?.subscription;
    if (sub?.stripeSubscriptionId) return true;
    // Trial users with active trial are considered to have an active subscription
    if (sub?.isTrial && sub.expirationDate && new Date(sub.expirationDate) > new Date()) return true;
    return false;
  }

  get isDelinquent(): boolean {
    if (!this.currentUser) return false;
    const sub = this.currentUser.subscription;
    // Only show payment banner when subscription is actually expired or missing
    const isExpired = sub?.expirationDate && new Date(sub.expirationDate) <= new Date();
    const hasNoSub = !sub?.stripeSubscriptionId && !sub?.isTrial;
    return this.currentUser.status === 'limited' && (isExpired || hasNoSub);
  }

  get delinquentPackage(): ServicePackage | undefined {
    const pkg = this.currentUser?.preferredPackage || this.currentUser?.subscription?.package;
    if (!pkg) return undefined;
    return this.publicPackages.find(p => p.id === pkg.id) || pkg as any;
  }

  get delinquentAmount(): string {
    const pkg = this.delinquentPackage;
    if (!pkg) return '0';
    const isMonthly = this.currentUser?.subscription?.isMonthly !== false;
    const price = isMonthly ? pkg.priceMonthly : pkg.priceYearly;
    return price % 1 === 0 ? price.toString() : price.toFixed(2);
  }

  get delinquentPeriod(): string {
    return this.currentUser?.subscription?.isMonthly !== false ? 'month' : 'year';
  }

  get selectedPackage(): ServicePackage | undefined {
    const found = this.publicPackages.find(p => p.id === this.currentPlanId);
    if (found) return found;
    // Defensive: never show the 'Select plan' placeholder while a real plan is
    // selected — fall back to the user's subscription package if the list
    // doesn't contain it (yet)
    const userPkg = this.currentUser?.subscription?.package;
    if (userPkg?.id && (userPkg.id === this.currentPlanId || !this.currentPlanId)) {
      return userPkg as ServicePackage;
    }
    return undefined;
  }

  /** Whether the EDU price applies to the current user on the given package. */
  private eduPriceActive(pkg: ServicePackage | undefined): boolean {
    return !!(this.currentUser?.eduDiscount && pkg?.eduDiscountEnabled);
  }

  private effMonthly(pkg: ServicePackage): number {
    return this.eduPriceActive(pkg) ? (pkg.priceMonthlyEdu ?? 0) : pkg.priceMonthly;
  }

  private effYearly(pkg: ServicePackage): number {
    return this.eduPriceActive(pkg) ? (pkg.priceYearlyEdu ?? 0) : pkg.priceYearly;
  }

  get priceInfoText(): string {
    const pkg = this.selectedPackage;
    if (!pkg) return '';
    const monthlyPrice = this.effMonthly(pkg);
    const yearlyPrice = this.effYearly(pkg);
    const hasMonthly = monthlyPrice > 0;
    const hasYearly = yearlyPrice > 0;
    if (!hasMonthly && !hasYearly) return this.translate.instant('USER_ACCOUNT.PRICE.FREE');
    if (!hasYearly) return this.translate.instant('USER_ACCOUNT.PRICE.MONTHLY_ONLY', { price: this.formatPrice(monthlyPrice) });
    if (!hasMonthly) return this.translate.instant('USER_ACCOUNT.PRICE.YEARLY_ONLY', { price: this.formatPrice(yearlyPrice) });
    const monthly = this.formatPrice(monthlyPrice);
    const yearly = this.formatPrice(yearlyPrice);
    const discount = Math.round((1 - yearlyPrice / (monthlyPrice * 12)) * 100);
    return discount > 0
      ? this.translate.instant('USER_ACCOUNT.PRICE.BOTH_DISCOUNT', { monthly, yearly, discount })
      : this.translate.instant('USER_ACCOUNT.PRICE.BOTH', { monthly, yearly });
  }

  get chargeInfoText(): string {
    const pkg = this.selectedPackage || this.publicPackages.find(p => p.id === this.savedPlanId);
    if (!pkg) return '';
    const amount = this.currentBillingPeriod === 'yearly'
      ? this.formatPrice(this.effYearly(pkg))
      : this.formatPrice(this.effMonthly(pkg));
    const nextDate = this.getNextBillingDate();
    return this.translate.instant('USER_ACCOUNT.CHARGE.MESSAGE', { amount, date: nextDate });
  }

  constructor(
    private matDialogRef: MatDialogRef<UserAccountDialogComponent>,
    private userService: UserService,
    private packagesService: PackageService,
    private paymentService: PaymentService,
    private dialog: MatDialog,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.seedAccordionState();

    this.currentUser = this.userService.getCurrentUserFromStorage();
    const userId = this.currentUser?.id;

    if (userId) {
      this.userService.getOne(userId).subscribe(user => {
        this.currentUser = user;
        this.savedEmail = user.email || '';
        this.savedBillingName = user.billingName || '';

        if (user.subscription) {
          this.savedBillingPeriod = user.subscription.isMonthly ? 'monthly' : 'yearly';
          this.currentBillingPeriod = this.savedBillingPeriod;
          if (user.subscription.package?.id) {
            this.savedPlanId = user.subscription.package.id;
          }
        }

        this.userLoaded = true;
        this.onDataReady();
      });
    }

    this.packagesService.getAllPublicPackages().subscribe(packages => {
      // Test plans are only visible when the client opts in via localStorage
      // (set `showTestPlans` to 'true'). Keeps live-payment test plans hidden
      // from real users.
      const showTestPlans = localStorage.getItem('showTestPlans') === 'true';
      const visible = packages.filter(p => showTestPlans || !p.isTestPlan);
      this.publicPackages = this.packagesService.isDev()
        ? visible
        : visible.filter(p => p.name.toLowerCase() !== 'developer');
      this.packagesLoaded = true;
      this.onDataReady();
      this.ensureCurrentPlanInList();
    });

    this.paymentService.getPaymentMethod().subscribe({
      next: pm => {
        this.paymentMethodInfo = pm;
      },
      error: () => {
        this.paymentMethodInfo = null;
      }
    });
  }

  private onDataReady(): void {
    if (!this.userLoaded || !this.packagesLoaded) return;

    if (!this.savedPlanId && this.publicPackages.length > 0) {
      const defaultPkg = this.publicPackages.find(p => p.isDefault) || this.publicPackages[0];
      this.savedPlanId = defaultPkg.id;
    }

    this.currentPlanId = this.savedPlanId;
    this.currentEmail = this.savedEmail;
    this.currentBillingName = this.savedBillingName;
    this.ensureCurrentPlanInList();
  }

  private ensureCurrentPlanInList(): void {
    if (!this.currentUser?.subscription?.package) return;
    const userPkg = this.currentUser.subscription.package;
    if (userPkg.name?.toLowerCase() === 'defaulter') return;
    const alreadyInList = this.publicPackages.some(p => p.id === userPkg.id);
    if (!alreadyInList) {
      this.publicPackages = [userPkg, ...this.publicPackages];
    }
  }

  ngAfterViewInit(): void {
    this.initStripe();
  }

  ngOnDestroy(): void {
    if (this.card) {
      this.card.destroy();
    }
    if (this.delinquentCard) {
      this.delinquentCard.destroy();
    }
  }

  private seedAccordionState(): void {
    const key = 'maporium-accordion-item-expand';
    const stored = localStorage.getItem(key);
    const state = stored ? JSON.parse(stored) : {};
    if (state['service'] === undefined) state['service'] = true;
    if (state['billing'] === undefined) state['billing'] = true;
    if (state['dangerZone'] === undefined) state['dangerZone'] = false;
    localStorage.setItem(key, JSON.stringify(state));
  }

  private async initStripe(): Promise<void> {
    if (!environment.stripePublishableKey || this.stripeInitialized) return;
    const Stripe = await loadStripe();
    this.stripe = Stripe(environment.stripePublishableKey);
    this.stripeInitialized = true;
  }

  private async mountCardElement(): Promise<void> {
    if (!this.stripe) await this.initStripe();
    if (!this.stripe) return;
    const elements = this.stripe.elements();
    const style = {
      base: {
        fontFamily: 'inherit',
        fontSize: '14px',
        color: '#333',
        '::placeholder': {color: '#aaa'}
      }
    };
    this.card = elements.create('card', {style, hideIcon: true});

    setTimeout(() => {
      const el = document.getElementById('account-card-element');
      if (el) {
        this.card.mount(el);
        this.card.on('change', (event: any) => {
          this.cardComplete = event.complete;
          this.cdr.detectChanges();
        });
      }
    }, 50);
  }

  // --- Plan ---
  selectPlan(pkg: ServicePackage): void {
    this.currentPlanId = pkg.id;
    this.planDirty = this.currentPlanId !== this.savedPlanId;
  }

  cancelPlan(): void {
    this.currentPlanId = this.savedPlanId;
    this.planDirty = false;
  }

  confirmPlan(): void {
    const pkg = this.selectedPackage;
    if (!this.hasActiveSubscription) {
      this.promptSubscription(pkg?.id || this.currentPlanId, pkg?.title || this.translate.instant('USER_ACCOUNT.FALLBACK.SELECTED'));
      return;
    }
    const oldPkg = this.publicPackages.find(p => p.id === this.savedPlanId);
    const oldTitle = oldPkg?.title || this.translate.instant('USER_ACCOUNT.FALLBACK.CURRENT_PLAN');
    const newTitle = pkg?.title || this.translate.instant('USER_ACCOUNT.FALLBACK.NEW_PLAN');

    let message = this.translate.instant('USER_ACCOUNT.PLAN_CHANGE.MESSAGE', { oldPlan: oldTitle, newPlan: newTitle, email: this.savedEmail });

    if (!this.isOnActiveTrial) {
      const prorationInfo = this.calculateProration(oldPkg, pkg);
      if (prorationInfo) {
        // A charge is collected immediately; a reimbursement is applied as account
        // credit toward future payments (Stripe credits the balance, not the card).
        message += prorationInfo.type === 'reimbursed'
          ? this.translate.instant('USER_ACCOUNT.PLAN_CHANGE.PRORATION_REIMBURSED', { amount: '$' + prorationInfo.amount })
          : this.translate.instant('USER_ACCOUNT.PLAN_CHANGE.PRORATION_CHARGED', { amount: '$' + prorationInfo.amount });
      }
    }

    this.openConfirmation(
      this.translate.instant('USER_ACCOUNT.CONFIRM.TITLE', { feature: this.translate.instant('USER_ACCOUNT.FEATURE.SERVICE_PLAN') }),
      pkg?.icon || 'icon-smap-plan-seeker',
        message,
      () => {
        this.userService.changeServicePlan(this.currentPlanId).subscribe({
          next: () => {
            this.savedPlanId = this.currentPlanId;
            this.planDirty = false;
            this.cdr.detectChanges();
            this.refreshUser();
          },
          error: (err) => {
            if (err?.error?.code === 'SUBSCRIPTION_INACTIVE') {
              this.promptSubscription(this.currentPlanId, pkg?.title || this.translate.instant('USER_ACCOUNT.FALLBACK.SELECTED'));
            } else {
              this.showError(this.translate.instant('USER_ACCOUNT.FEATURE.SERVICE_PLAN'), err);
            }
          }
        });
      }
    );
  }

  // --- Email ---
  onEmailChange(): void {
    this.emailDirty = this.currentEmail !== this.savedEmail;
  }

  onEmailConfirmChange(): void {
    // Just triggers change detection for emailValid getter
  }

  cancelEmail(): void {
    this.currentEmail = this.savedEmail;
    this.currentEmailConfirm = '';
    this.emailDirty = false;
    this.emailInputRef?.nativeElement?.blur();
  }

  confirmEmail(): void {
    let message = this.translate.instant('USER_ACCOUNT.EMAIL_CHANGE.MESSAGE', { oldEmail: this.savedEmail, newEmail: this.currentEmail });

    // Crossing the .edu boundary flips the educational discount. Describe the
    // pricing impact when the user's plan actually offers an educational discount.
    const pkg = this.publicPackages.find(p => p.id === this.savedPlanId) || this.currentUser?.subscription?.package;
    const wasEdu = isEduEmail(this.savedEmail);
    const nowEdu = isEduEmail(this.currentEmail);
    if (wasEdu !== nowEdu && pkg?.eduDiscountEnabled) {
      const isMonthly = this.currentUser?.subscription?.isMonthly !== false;
      const regular = isMonthly ? pkg.priceMonthly : pkg.priceYearly;
      const edu = isMonthly ? (pkg.priceMonthlyEdu ?? 0) : (pkg.priceYearlyEdu ?? 0);
      const discountPct = regular > 0 ? Math.round((1 - edu / regular) * 100) : 0;
      const temporal = nowEdu
        ? this.translate.instant('USER_ACCOUNT.EMAIL_CHANGE.EDU_TEMPORAL_NOW')
        : this.translate.instant('USER_ACCOUNT.EMAIL_CHANGE.EDU_TEMPORAL_NO_LONGER');
      message += this.translate.instant('USER_ACCOUNT.EMAIL_CHANGE.EDU_DISCOUNT', { temporal, percent: discountPct });

      if (this.hasActiveSubscription && !this.isOnActiveTrial) {
        const proration = this.calculateEduProration(pkg, nowEdu);
        if (proration) {
          // Switching to .edu lowers the price → account credit toward future
          // payments; leaving .edu raises it → immediate charge.
          message += proration.type === 'reimbursed'
            ? this.translate.instant('USER_ACCOUNT.EMAIL_CHANGE.EDU_PRORATION_REIMBURSED', { amount: '$' + proration.amount })
            : this.translate.instant('USER_ACCOUNT.EMAIL_CHANGE.EDU_PRORATION_CHARGED', { amount: '$' + proration.amount });
        }
      }
    }

    this.openConfirmation(
      this.translate.instant('USER_ACCOUNT.CONFIRM.TITLE', { feature: this.translate.instant('USER_ACCOUNT.FEATURE.EMAIL_ADDRESS') }),
      'icon-smap-user-email',
      message,
      () => {
        this.userService.changeEmail(this.currentEmail).subscribe({
          next: () => {
            this.savedEmail = this.currentEmail;
            this.currentEmailConfirm = '';
            this.emailDirty = false;
            this.refreshUser();
            // Changing to a .edu address (even from another .edu one) prompts the
            // user to review their organization in the profile dialog
            if (nowEdu) {
              this.dialog.open(UserProfileDialogComponent, {
                width: '35%',
                autoFocus: false,
                data: {focusOrganization: true},
              });
            }
          },
          error: (err) => {
            const status = err?.status;
            const serverMsg = err?.error?.message || '';
            if (status === 409 && serverMsg) {
              this.dialog.open(ConfirmationDialogComponent, {
                width: '540px',
                maxWidth: '90vw',
                data: {
                  title: this.translate.instant('USER_ACCOUNT.ERROR.TITLE', { feature: this.translate.instant('USER_ACCOUNT.FEATURE.EMAIL_ADDRESS') }),
                  iconClass: 'icon-smap-concept-warning',
                  message: serverMsg,
                  showCancel: false,
                  confirmText: this.translate.instant('USER_ACCOUNT.BUTTONS.TRY_AGAIN'),
                }
              });
            } else {
              this.showError(this.translate.instant('USER_ACCOUNT.FEATURE.EMAIL_ADDRESS'), err);
            }
          }
        });
      }
    );
  }

  // --- Billing Period ---
  onBillingPeriodChange(value: 'monthly' | 'yearly'): void {
    this.currentBillingPeriod = value;
    this.billingPeriodDirty = this.currentBillingPeriod !== this.savedBillingPeriod;
    if (this.currentBillingPeriod === this.savedBillingPeriod) {
      this.billingPeriodFocused = false;
    }
  }

  cancelBillingPeriod(): void {
    this.currentBillingPeriod = this.savedBillingPeriod;
    this.billingPeriodDirty = false;
    this.billingPeriodFocused = false;
  }

  confirmBillingPeriod(): void {
    if (!this.hasActiveSubscription) {
      const pkg = this.selectedPackage || this.publicPackages.find(p => p.id === this.savedPlanId);
      this.promptSubscription(pkg?.id || this.savedPlanId, pkg?.title || this.translate.instant('USER_ACCOUNT.FALLBACK.SELECTED'));
      return;
    }
    this.openConfirmation(
      this.translate.instant('USER_ACCOUNT.CONFIRM.TITLE', { feature: this.translate.instant('USER_ACCOUNT.FEATURE.BILLING_PERIOD') }),
      'icon-smap-billing-cycle',
      this.translate.instant('USER_ACCOUNT.BILLING_PERIOD_CHANGE.MESSAGE', { oldPeriod: this.savedBillingPeriod, newPeriod: this.currentBillingPeriod, email: this.savedEmail }),
      () => {
        this.userService.changeBillingPeriod(this.currentBillingPeriod).subscribe({
          next: () => {
            this.savedBillingPeriod = this.currentBillingPeriod;
            this.billingPeriodDirty = false;
            this.billingPeriodFocused = false;
            this.cdr.detectChanges();
            this.refreshUser();
          },
          error: (err) => {
            if (err?.error?.code === 'SUBSCRIPTION_INACTIVE') {
              const pkg = this.selectedPackage || this.publicPackages.find(p => p.id === this.savedPlanId);
              this.promptSubscription(pkg?.id || this.savedPlanId, pkg?.title || this.translate.instant('USER_ACCOUNT.FALLBACK.SELECTED'));
            } else {
              this.showError(this.translate.instant('USER_ACCOUNT.FEATURE.BILLING_PERIOD'), err);
            }
          }
        });
      }
    );
  }

  // --- Billing Name ---
  onBillingNameChange(): void {
    this.billingNameDirty = this.currentBillingName !== this.savedBillingName;
  }

  cancelBillingName(): void {
    this.currentBillingName = this.savedBillingName;
    this.billingNameDirty = false;
    this.billingNameInputRef?.nativeElement?.blur();
  }

  confirmBillingName(): void {
    this.openConfirmation(
      this.translate.instant('USER_ACCOUNT.CONFIRM.TITLE', { feature: this.translate.instant('USER_ACCOUNT.FEATURE.BILLING_NAME') }),
      'icon-smap-account-individual',
      this.translate.instant('USER_ACCOUNT.BILLING_NAME_CHANGE.MESSAGE', { oldName: this.savedBillingName, newName: this.currentBillingName, email: this.savedEmail }),
      () => {
        this.userService.changeBillingName(this.currentBillingName).subscribe({
          next: () => {
            this.savedBillingName = this.currentBillingName;
            this.billingNameDirty = false;
            this.refreshUser();
          },
          error: (err) => this.showError(this.translate.instant('USER_ACCOUNT.FEATURE.BILLING_NAME'), err)
        });
      }
    );
  }

  // --- Card ---
  startCardEdit(): void {
    if (!this.hasActiveSubscription) {
      const pkg = this.selectedPackage || this.publicPackages.find(p => p.id === this.savedPlanId);
      this.promptSubscription(pkg?.id || this.savedPlanId, pkg?.title || 'selected');
      return;
    }
    this.cardEditing = true;
    this.cardComplete = false;
    this.cdr.detectChanges();
    this.mountCardElement();
  }

  cancelCard(): void {
    this.cardEditing = false;
    this.cardComplete = false;
    if (this.card) {
      this.card.destroy();
      this.card = null;
    }
  }

  async confirmCard(): Promise<void> {
    if (!this.stripe || !this.card || !this.currentUser?.id) return;

    try {
      // Step 1: Confirm card setup with Stripe FIRST
      const setupRes = await this.paymentService.createSetupIntent(this.currentUser!.id).toPromise();
      const setupResult = await this.stripe.confirmCardSetup(setupRes!.clientSecret, {
        payment_method: {card: this.card}
      });

      if (setupResult.error) {
        this.showError(this.translate.instant('USER_ACCOUNT.FEATURE.CARD_NUMBER'), {error: {message: setupResult.error.message}});
        return;
      }

      const paymentMethodId = setupResult.setupIntent.payment_method;

      // Step 2: Fetch new card last4 from backend
      let newLast4 = '----';
      try {
        const res = await this.paymentService.getPaymentMethodLast4(paymentMethodId).toPromise();
        newLast4 = res?.last4 || '----';
      } catch (_) { /* ignore */
      }

      const oldLast4 = this.paymentMethodInfo?.last4 || '----';

      // Step 3: Show confirmation dialog with old/new last4
      this.openConfirmation(
        this.translate.instant('USER_ACCOUNT.CONFIRM.TITLE', { feature: this.translate.instant('USER_ACCOUNT.FEATURE.CARD_NUMBER') }),
        'icon-smap-billing-card',
        this.translate.instant('USER_ACCOUNT.CARD_CHANGE.MESSAGE', { oldLast4, newLast4, email: this.savedEmail }),
        () => {
          this.paymentService.updateCard(paymentMethodId).subscribe({
            next: () => {
              this.cardEditing = false;
              if (this.card) {
                this.card.destroy();
                this.card = null;
              }
              this.paymentService.getPaymentMethod().subscribe(pm => {
                this.paymentMethodInfo = pm;
                this.cdr.detectChanges();
              });
            },
            error: (err) => this.showError(this.translate.instant('USER_ACCOUNT.FEATURE.CARD_NUMBER'), err)
          });
        }
      );
    } catch (err: any) {
      this.showError(this.translate.instant('USER_ACCOUNT.FEATURE.CARD_NUMBER'), err);
    }
  }

  // --- Close Account ---
  onCloseAccount(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      width: '540px',
      maxWidth: '90vw',
      data: {
        title: this.translate.instant('USER_ACCOUNT.CLOSE_ACCOUNT.TITLE'),
        icon: 'dangerous',
        message: this.translate.instant('USER_ACCOUNT.CLOSE_ACCOUNT.MESSAGE'),
        cancelText: this.translate.instant('USER_ACCOUNT.BUTTONS.CANCEL'),
        confirmText: this.translate.instant('USER_ACCOUNT.BUTTONS.PROCEED'),
        onConfirm: () => {
          this.userService.sendCloseAccountLink().subscribe(() => {
            this.userService.logout();
            this.matDialogRef.close();
            this.router.navigate(['/close-account'], { queryParams: { email: this.currentUser?.email } });
          });
        }
      }
    });
  }

  close(): void {
    this.matDialogRef.close();
  }

  startPayNow(): void {
    this.payNowMode = true;
    this.delinquentCardComplete = false;
    this.cdr.detectChanges();
    this.mountDelinquentCardElement();
  }

  cancelPayNow(): void {
    this.payNowMode = false;
    this.delinquentCardComplete = false;
    this.delinquentProcessing = false;
    if (this.delinquentCard) {
      this.delinquentCard.destroy();
      this.delinquentCard = null;
    }
  }

  async processPayNow(): Promise<void> {
    if (!this.stripe || !this.delinquentCard || !this.currentUser?.id) return;

    this.delinquentProcessing = true;
    this.cdr.detectChanges();

    try {
      const pkg = this.currentUser.preferredPackage || this.currentUser.subscription?.package;
      if (!pkg?.id) throw new Error('No package found for renewal');

      const billingInterval: 'monthly' | 'yearly' = this.currentUser.subscription?.isMonthly !== false ? 'monthly' : 'yearly';

      // Step 1: Create setup intent
      const setupRes = await this.paymentService.createSetupIntent(this.currentUser.id).toPromise();

      // Step 2: Confirm card setup with Stripe
      const setupResult = await this.stripe.confirmCardSetup(setupRes!.clientSecret, {
        payment_method: {
          card: this.delinquentCard,
          billing_details: {email: this.currentUser.email}
        }
      });

      if (setupResult.error) {
        this.showError(this.translate.instant('USER_ACCOUNT.FEATURE.PAYMENT'), {error: {message: setupResult.error.message}});
        this.delinquentProcessing = false;
        this.cdr.detectChanges();
        return;
      }

      const paymentMethodId = setupResult.setupIntent.payment_method;

      // Step 3: Create subscription
      const subRes = await this.paymentService.createSubscription(
        this.currentUser.id, pkg.id, billingInterval, paymentMethodId
      ).toPromise();

      // Step 4: Confirm payment if required
      if (subRes?.clientSecret) {
        const paymentResult = await this.stripe.confirmCardPayment(subRes.clientSecret);
        if (paymentResult.error) {
          this.showError(this.translate.instant('USER_ACCOUNT.FEATURE.PAYMENT'), {error: {message: paymentResult.error.message}});
          this.delinquentProcessing = false;
          this.cdr.detectChanges();
          return;
        }
      } else if (subRes?.status !== 'active' && subRes?.status !== 'trialing') {
        // No clientSecret and subscription not active — payment failed (e.g. 0341 card)
        this.showError(this.translate.instant('USER_ACCOUNT.FEATURE.PAYMENT'), {error: {message: this.translate.instant('USER_ACCOUNT.PAYMENT.PROCESS_ERROR')}});
        this.delinquentProcessing = false;
        this.cdr.detectChanges();
        return;
      }

      // Success
      this.payNowSuccess = true;
      this.payNowMode = false;
      this.delinquentProcessing = false;
      if (this.delinquentCard) {
        this.delinquentCard.destroy();
        this.delinquentCard = null;
      }
      this.cdr.detectChanges();

      // Refresh user data (no auto-close — let user read success message)
      this.userService.refreshLocalUser().subscribe();
      this.paymentService.getPaymentMethod().subscribe({
        next: pm => {
          this.paymentMethodInfo = pm;
          this.cdr.detectChanges();
        }
      });
    } catch (err: any) {
      this.showError(this.translate.instant('USER_ACCOUNT.FEATURE.PAYMENT'), err);
      this.delinquentProcessing = false;
      this.cdr.detectChanges();
    }
  }

  private async mountDelinquentCardElement(): Promise<void> {
    if (!this.stripe) await this.initStripe();
    if (!this.stripe) return;
    const elements = this.stripe.elements();
    const style = {
      base: {
        fontFamily: 'inherit',
        fontSize: '14px',
        color: '#333',
        '::placeholder': {color: '#aaa'}
      }
    };
    this.delinquentCard = elements.create('card', {style, hideIcon: true});

    setTimeout(() => {
      const el = document.getElementById('delinquent-card-element');
      if (el) {
        this.delinquentCard.mount(el);
        this.delinquentCard.on('change', (event: any) => {
          this.delinquentCardComplete = event.complete;
          this.cdr.detectChanges();
        });
        this.delinquentCard.on('ready', () => this.delinquentCard?.focus());
      }
    }, 50);
  }

  // --- Helpers ---
  padZero(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }

  private formatPrice(price: number): string {
    if (!price) return '0';
    return price % 1 === 0 ? price.toString() : price.toFixed(2);
  }

  /**
   * Prorated difference when the educational discount is toggled on the same
   * package (regular price vs EDU price) for the user's current billing cycle.
   * `enableEdu` true → moving to the cheaper EDU price → reimbursed; false → charged.
   */
  private calculateEduProration(
      pkg: ServicePackage,
      enableEdu: boolean
  ): { type: string; amount: string } | null {
    const sub = this.currentUser?.subscription;
    if (!sub?.expirationDate) return null;

    const isMonthly = sub.isMonthly !== false;
    const regular = isMonthly ? pkg.priceMonthly : pkg.priceYearly;
    const edu = isMonthly ? (pkg.priceMonthlyEdu ?? 0) : (pkg.priceYearlyEdu ?? 0);
    if (regular === edu) return null;

    const now = new Date();
    const expiration = new Date(sub.expirationDate);
    const daysRemaining = Math.max(0, (expiration.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
    const totalDays = isMonthly ? 30 : 365;
    const proratedAmount = Math.abs((regular - edu) * daysRemaining / totalDays);
    const rounded = proratedAmount < 0.01 ? '0.01' : proratedAmount.toFixed(2);

    return {
      type: enableEdu ? 'reimbursed' : 'charged',
      amount: rounded,
    };
  }

  private calculateProration(
      oldPkg: ServicePackage | undefined,
      newPkg: ServicePackage | undefined
  ): { type: string; amount: string } | null {
    if (!oldPkg || !newPkg) return null;
    const sub = this.currentUser?.subscription;
    if (!sub?.expirationDate) return null;

    const isMonthly = sub.isMonthly !== false;
    const oldPrice = isMonthly ? this.effMonthly(oldPkg) : this.effYearly(oldPkg);
    const newPrice = isMonthly ? this.effMonthly(newPkg) : this.effYearly(newPkg);
    if (oldPrice === newPrice) return null;

    const now = new Date();
    const expiration = new Date(sub.expirationDate);
    const daysRemaining = Math.max(0, (expiration.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
    const totalDays = isMonthly ? 30 : 365;
    const proratedAmount = Math.abs((newPrice - oldPrice) * daysRemaining / totalDays);
    const rounded = proratedAmount < 0.01 ? '0.01' : proratedAmount.toFixed(2);

    return {
      type: newPrice > oldPrice ? 'charged' : 'reimbursed',
      amount: rounded,
    };
  }

  private getNextBillingDate(): string {
    const sub = this.currentUser?.subscription;
    const fmt: Intl.DateTimeFormatOptions = {year: 'numeric', month: 'long', day: 'numeric'};

    if (sub?.expirationDate) {
      // If on active trial and a different plan is selected, compute adjusted due date
      if (this.isOnActiveTrial && this.currentPlanId !== this.savedPlanId) {
        const oldPkg = this.publicPackages.find(p => p.id === this.savedPlanId);
        const newPkg = this.publicPackages.find(p => p.id === this.currentPlanId);
        if (oldPkg && newPkg) {
          const now = new Date();
          const oldRemainingMs = new Date(sub.expirationDate).getTime() - now.getTime();
          const MS_PER_DAY = 24 * 60 * 60 * 1000;
          const oldConfiguredDays = this.trialDaysTotal(oldPkg.freeTrialCount, oldPkg.freeTrialUnit);
          const newConfiguredDays = this.trialDaysTotal(newPkg.freeTrialCount, newPkg.freeTrialUnit);
          const newRemainingMs = Math.min(oldRemainingMs, newConfiguredDays * MS_PER_DAY)
            + Math.max(0, (newConfiguredDays - oldConfiguredDays) * MS_PER_DAY);
          const newDueDate = new Date(now.getTime() + Math.max(0, newRemainingMs));
          return newDueDate.toLocaleDateString('en-US', fmt);
        }
      }
      return new Date(sub.expirationDate).toLocaleDateString('en-US', fmt);
    }

    const d = new Date();
    if (this.currentBillingPeriod === 'yearly') {
      d.setFullYear(d.getFullYear() + 1);
    } else {
      d.setMonth(d.getMonth() + 1);
    }
    return d.toLocaleDateString('en-US', fmt);
  }

  private trialDaysTotal(count: number, unit: string): number {
    switch (unit) {
      case 'days':
        return count;
      case 'weeks':
        return count * 7;
      case 'months':
        return count * 30;
      default:
        return count * 7;
    }
  }

  private openConfirmation(title: string, iconClass: string, message: string, onProceed: () => void): void {
    this.dialog.open(ConfirmationDialogComponent, {
      width: '540px',
      maxWidth: '90vw',
      data: {
        title,
        iconClass,
        message,
        cancelText: this.translate.instant('USER_ACCOUNT.BUTTONS.CANCEL_UPPER'),
        confirmText: this.translate.instant('USER_ACCOUNT.BUTTONS.PROCEED_UPPER'),
        onConfirm: onProceed,
      }
    });
  }

  private showError(feature: string, err: any): void {
    let systemMsg = err?.error?.message || err?.message || '';
    // Rewrite Stripe inactive-product error to be more user-friendly
    const inactiveMatch = systemMsg.match(/The product (prod_\w+) is marked as inactive.*?You provided the plan (price_\w+)/);
    if (inactiveMatch) {
      systemMsg = this.translate.instant('USER_ACCOUNT.ERROR.PRODUCT_INACTIVE', { product: inactiveMatch[1], plan: inactiveMatch[2] });
    }
    this.dialog.open(ConfirmationDialogComponent, {
      width: '540px',
      maxWidth: '90vw',
      data: {
        title: this.translate.instant('USER_ACCOUNT.ERROR.TITLE', { feature }),
        iconClass: 'icon-smap-concept-warning',
        message: this.translate.instant('USER_ACCOUNT.ERROR.MESSAGE', { feature: feature.toLowerCase() }),
        errorMessage: systemMsg || undefined,
        showCancel: false,
        confirmText: this.translate.instant('USER_ACCOUNT.BUTTONS.TRY_AGAIN'),
      }
    });
  }

  private promptSubscription(packageId: string, packageTitle: string): void {
    this.dialog.open(ConfirmationDialogComponent, {
      width: '540px',
      maxWidth: '90vw',
      data: {
        title: this.translate.instant('USER_ACCOUNT.NO_SUBSCRIPTION.TITLE'),
        iconClass: 'icon-smap-concept-warning',
        message: this.translate.instant('USER_ACCOUNT.NO_SUBSCRIPTION.MESSAGE', { plan: packageTitle }),
        cancelText: this.translate.instant('USER_ACCOUNT.BUTTONS.CANCEL_UPPER'),
        confirmText: this.translate.instant('USER_ACCOUNT.BUTTONS.SUBSCRIBE'),
        onConfirm: () => {
          this.dialog.closeAll();
          this.router.navigate(['/payment'], {queryParams: {plan: packageId}});
        }
      }
    });
  }

  refreshUser(): void {
    this.userService.refreshLocalUser().subscribe(() => {
      this.packagesService.loadUserPackage().subscribe(() => {
        this.currentUser = this.userService.getCurrentUserFromStorage();
        this.syncFromUser();
      });
    });
  }

  // Re-derive plan and billing period state from the freshly fetched user —
  // same effect as closing and reopening the dialog
  private syncFromUser(): void {
    const sub = this.currentUser?.subscription;
    if (sub) {
      this.savedBillingPeriod = sub.isMonthly ? 'monthly' : 'yearly';
      if (!this.billingPeriodDirty) {
        this.currentBillingPeriod = this.savedBillingPeriod;
      }
      if (sub.package?.id) {
        this.savedPlanId = sub.package.id;
        if (!this.planDirty) {
          this.currentPlanId = this.savedPlanId;
        }
      }
    }
    this.ensureCurrentPlanInList();
    this.cdr.detectChanges();
  }
}
